export const RESOLUTION_FILTER_EXPAND: FilterExpandDetails = { name: "Resolution", properties: ["DraftKB", "ResolutionCategoryId", "Note", "InternalNote"] };

// The requester detail filters are keyed by the bare user property, which the Ticket entity does not have.
export const REQUESTER_FILTER_EXPAND: FilterExpandDetails = {
  name: "Requester",
  properties: ["JobTitle", "Department", "CompanyName", "EmployeeId", "StreetAddress", "State", "Country", "Office", "City", "ZipCode", "OfficePhone", "MobilePhone", "IsExternalUser", "Source"]
};

export const TICKET_FILTER_EXPANSIONS = [RESOLUTION_FILTER_EXPAND, REQUESTER_FILTER_EXPAND];

export const getFilterPropertyPath = (key: string, expansions?: FilterExpandDetails[]) => {
  const expansion = expansions?.find(ep => ep.properties.includes(key));
  return expansion ? `${expansion.name}/${key}` : key;
};

// OData accepts an enum only by its member name, so a filter on one must send names rather than the stored numbers.
export const getEnumFilterQuery = (path: string, values: number[], toName: (value: number) => string) => {
  const names = values.map(value => `'${toName(value)}'`);
  return names.length === 1 ? `${path} eq ${names[0]}` : `${path} in (${names.join(',')})`;
};
